import { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { HabitFrequencyType, SpecialDays } from '../dto/habit.enum';

interface TimeCountProps {
  count: number;
  frequency: HabitFrequencyType;
  specialDays?: SpecialDays;
}

export function TimeCount({ count, frequency, specialDays }: TimeCountProps): JSX.Element {
  const { t } = useTranslation();

  const translationConfig = {
    cnt: count,
    frequency: [HabitFrequencyType.WEEKLY, HabitFrequencyType.WEEK_DAYS].includes(frequency)
      ? t('week')
      : specialDays === SpecialDays.EMBER
      ? t('year')
      : t('month'),
    plural: false,
  };

  return (
    <>
      {count === 1
        ? t('{{cnt}} time a {{frequency}}', translationConfig)
        : t('{{cnt}} times a {{frequency}}', translationConfig)}
    </>
  );
}
